import { render, staticRenderFns } from "./app-welcome.vue?vue&type=template&id=755ad45f&"
import script from "./app-welcome.vue?vue&type=script&lang=js&"
export * from "./app-welcome.vue?vue&type=script&lang=js&"
import style0 from "./app-welcome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports